import {
  TextManager,
  formatNumberVariableWithUnicode,
  renderMarkdownComponent,
} from "Components/TextContext";
import React, { ReactElement } from "react";
import { StyledTotalPrice, TotalPriceText } from "./discountMessageStyled";

import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { isDefined } from "Utils/functions";

interface Props {
  readonly totalPriceValue?: number;
  readonly isLoading?: boolean;
}

export const TotalPriceValue = ({
  totalPriceValue,
  isLoading,
}: Props): ReactElement | null => {
  const { getText } = TextManager;

  if (!isDefined(totalPriceValue)) {
    return null;
  }

  return (
    <TotalPriceText>
      <StyledTotalPrice className="total-price">
        {isLoading ? (
          <ThemedSpinner black />
        ) : (
          <>
            {renderMarkdownComponent(
              getText("discountmessage.common.totalprice", {
                variables: {
                  discountMessage_value:
                    formatNumberVariableWithUnicode(totalPriceValue),
                },
              }),
            )}
          </>
        )}
      </StyledTotalPrice>
    </TotalPriceText>
  );
};
